<script>
import { get } from "lodash"

export default {
  props: {
    value: { type: Object, required: true }
  },

  computed: {
    sendLower() {
      return get(this.value, "sendLower.value", "")
    },
    sendUpper() {
      return get(this.value, "sendUpper.value", "")
    },
    sendLowerMax() {
      return this.sendUpper
    },
    sendUpperMin() {
      return this.sendLower
    },
  },

  methods: {

    //  0 web                 Kladd
    //  1 ordered             Bestilt
    //  2 confirmedWaba       Bekreftet
    //  3 picked              Plukket
    //  4 sent                Sendt
    //  5 confirmed           Mottatt
    //  6 notAgreed           Uenighet
    //  7 cancelledWaba       Kansellert
    //  9 waitForSort         Sorteres
    // 10 treatment           Under beh.
    // 11 waitForConfirmation Bekr. kunde
    // 12 receivedSort        Ankommet
    // 13 waitForAccept       Sortert
    // 14 waitForAgreement    Sortert m/m

    getLabel(status) {
      if (status.label) {
        return status.label
      } else {
        return status.id === 0 ? this.$tk("Common.OrderStatus.Draft") :
          status.id === 1 ? this.$tk("Common.OrderStatus.Ordered") :
            status.id === 2 ? this.$tk("Common.OrderStatus.ConfirmedWabaShort") :
              status.id === 3 ? this.$tk("Common.OrderStatus.PickedShort") :
                status.id === 4 ? this.$tk("Common.OrderStatus.Sent") :
                  status.id === 5 ? this.$tk("Common.OrderStatus.Received") :
                    status.id === 6 ? this.$tk("Common.OrderStatus.NotAgreed") :
                      status.id === 7 ? this.$tk("Common.OrderStatus.CancelledWabaShort") :
                        status.id === 9 ? this.$tk("Common.OrderStatus.WaitForSort") :
                          status.id === 10 ? this.$tk("Common.OrderStatus.TreatmentShort") :
                            status.id === 11 ? this.$tk("Common.OrderStatus.WaitForConfirmationShort") :
                              status.id === 12 ? this.$tk("Common.OrderStatus.ReceivedSortShort") :
                                status.id === 13 ? this.$tk("Common.OrderStatus.WaitForAccept") :
                                  status.id === 14 ? this.$tk("Common.OrderStatus.WaitForAgreementShort") : ""
      }
    },

    set(property, value) {
      const filters = { ...this.value }
      filters[property].value = value
      this.$emit("input", filters)
    },

    setStatus(index, $event) {
      const filters = { ...this.value }
      filters.statuses[index].value = $event
      this.$emit("input", filters)
    }

  }

}
</script>

<template>
  <div class="flex flex-wrap items-center gap-2">
    <div class="flex flex-row flex-wrap md:flex-no-wrap">
      <PToggle
        v-for="(status, index) in value.statuses"
        v-show="status.visible !== false"
        :key="index"
        :label="getLabel(status)"
        :stacked="true"
        :value="status.value"
        class="w-20 my-auto"
        @input="setStatus(index, $event)"
      />
    </div>

    <div class="flex space-x-4">
      <PDatePicker
        v-if="value.sendLower && value.sendLower.visible !== false"
        :allOpen="true"
        :clearable="true"
        :max="sendLowerMax"
        :placeholder="$tk('Common.General.FromDate')"
        :value="sendLower"
        class="w-36"
        @input="set('sendLower', $event)"
      />

      <PDatePicker
        v-if="value.sendUpper && value.sendUpper.visible !== false"
        :allOpen="true"
        :clearable="true"
        :min="sendUpperMin"
        :placeholder="$tk('Common.General.ToDate')"
        :rightAlign="true"
        :value="sendUpper"
        class="w-36"
        @input="set('sendUpper', $event)"
      />

      <PInput
        v-if="value.term && value.term.visible !== false"
        :clearable="true"
        :placeholder="$tk('Common.General.SearchText', true)"
        :value="value.term.value"
        :wait="250"
        class="min-w-8 md:w-36"
        icon-inside-left="search"
        @input="set('term', $event)"
      />

    </div>

  </div>
</template>
